import { useParams, useNavigate } from 'react-router-dom';
import { serviceDetails } from '../../data/serviceDetails';
import './ServiceDetail.css';

function ServiceDetail({ onOpenModal }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = serviceDetails.find((s) => s.slug === slug);

  if (!service) {
    return (
      <div className="sd-not-found">
        <p>Service not found.</p>
        <button onClick={() => navigate('/')}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="sd-page">

      {/* Hero */}
      <section className="sd-hero">
        <button className="sd-back" onClick={() => navigate(-1)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          Back
        </button>
        <span className="sd-pre">Our Services</span>
        <h1 className="sd-headline">{service.heroHeadline}</h1>
        <p className="sd-intro">{service.intro}</p>
        <button className="sd-cta-btn" onClick={onOpenModal}>
          Book a Free Consultation
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </section>

      {/* Benefits */}
      <section className="sd-benefits">
        <h2 className="sd-section-title">Key Benefits</h2>
        <div className="sd-benefits-grid">
          {service.benefits.map((b, i) => (
            <div key={i} className="sd-benefit-card">
              <div className="sd-benefit-num">0{i + 1}</div>
              <h3>{b.title}</h3>
              <p>{b.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Callout */}
      <section className="sd-callout">
        <div className="sd-callout-inner">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="40" height="40" className="sd-callout-icon">
            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
          </svg>
          <p>{service.callout}</p>
        </div>
      </section>

      {/* How It Works */}
      <section className="sd-steps">
        <h2 className="sd-section-title">How It Works</h2>
        <div className="sd-steps-list">
          {service.steps.map((s, i) => (
            <div key={i} className="sd-step">
              <div className="sd-step-num">{s.step}</div>
              <div className="sd-step-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Closing CTA */}
      <section className="sd-closing">
        <p>{service.closing}</p>
        <button className="sd-cta-btn" onClick={onOpenModal}>
          Book a Free Consultation
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </section>

    </div>
  );
}

export default ServiceDetail;
